import { useSite } from "../context/SiteContext";
import SectionHead from "../components/site/SectionHead";
import ProductCard from "../components/site/ProductCard";
import LeadForm from "../components/site/LeadForm";

export default function Loans() {
  const { products } = useSite();
  return (
    <div data-testid="loans-page" className="container-site py-14 lg:py-20">
      <SectionHead eyebrow="Loan Products" title="One Marketplace, Every Loan You Need"
        subtitle="Explore financing options based on your requirements, eligibility and available lending partners. All rates and terms are indicative and determined by the respective lender." />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
        {products.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
      <div className="mt-16"><LeadForm title="Not sure which loan fits? Tell us what you need." source="loans_page" /></div>
    </div>
  );
}
